import apiGd from "./apiGd";

const getAuthConfig = (token) => ({
  headers: { Authorization: `Bearer ${token}` },
});

export async function getBanners(token, params = {}) {
  const response = await apiGd.get("/admin/banners", {
    ...getAuthConfig(token),
    params,
  });
  return response.data;
}

export async function getBanner(id, token) {
  const response = await apiGd.get(`/admin/banners/${id}`, getAuthConfig(token));
  return response.data;
}

export async function createBanner(data, token) {
  const response = await apiGd.post("/admin/banners", data, getAuthConfig(token));
  return response.data;
}

export async function updateBanner(id, data, token) {
  const response = await apiGd.put(`/admin/banners/${id}`, data, getAuthConfig(token));
  return response.data;
}

export async function deleteBanner(id, token) {
  await apiGd.delete(`/admin/banners/${id}`, getAuthConfig(token));
}

// Reusa o upload existente — retorna { id, url, ... }.
export async function uploadBannerImage(file, token) {
  const formData = new FormData();
  formData.append("file", file);
  const response = await apiGd.post("admin/files", formData, {
    headers: { Authorization: `Bearer ${token}` },
  });
  return response.data;
}
